import { TranslationKeys } from '../types';

const colorNames: Record<string, string> = {
  red: 'rojo',
  blue: 'azul',
  yellow: 'amarillo',
  green: 'verde',
  white: 'blanco',
  black: 'negro',
  orange: 'naranja',
  purple: 'morado',
};

export const es: TranslationKeys = {
  skipToGenerator: 'Saltar al generador',
  headerTagline: 'Crea tu nombre con bloques estilo LEGO \u2014 generador online gratuito',
  enterName: 'Escribe tu nombre:',
  namePlaceholder: 'ESCRIBE TU NOMBRE',
  maxCharacters: 'M\u00e1ximo 20 caracteres',
  sizeLabel: 'Tama\u00f1o:',
  baseplateLabel: 'Base:',
  piecesNeeded: 'Piezas necesarias:',
  mainAriaLabel: 'Generador de nombre LEGO',
  rootAriaLabel: 'Generador de nombre en bloques LEGO',
  languageSwitcherLabel: 'Idioma',
  languageEn: 'Ingl\u00e9s',
  languageEs: 'Espa\u00f1ol',
  inventoryPlate: (size, color) => `placa ${colorNames[color] ?? color} ${size}x${size}`,
  inventoryBaseplate: (width, height) => `baseplate ${width}x${height}`,
  design3dButton: 'Letras con volumen',
  design3dBadge: 'Pr\u00f3ximamente',
  affiliateBuildTitle: '\u00a1Constr\u00fayelo en la vida real!',
  affiliateAmazonCta: 'Comprar caja de ladrillos en Amazon 🛒',
  affiliateLegoCta: 'Buscar piezas sueltas en LEGO Pick a Brick 🧱',
};
